var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyVehicle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 172,
    viewBox: "0 0 212 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 172,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.536 55.8999C178.814 55.8999 181.472 58.5951 181.472 61.9199C181.472 65.2447 178.814 67.9399 175.536 67.9399H141.616C144.894 67.9399 147.552 70.6351 147.552 73.9599C147.552 77.2847 144.894 79.9799 141.616 79.9799H160.272C163.55 79.9799 166.208 82.6751 166.208 85.9999C166.208 89.3247 163.55 92.0199 160.272 92.0199H151.645C147.511 92.0199 144.16 94.7151 144.16 98.0399C144.16 100.256 145.856 102.263 149.248 104.06C152.526 104.06 155.184 106.755 155.184 110.08C155.184 113.405 152.526 116.1 149.248 116.1H78.864C75.5857 116.1 72.928 113.405 72.928 110.08C72.928 106.755 75.5857 104.06 78.864 104.06H45.792C42.5137 104.06 39.856 101.365 39.856 98.0399C39.856 94.7151 42.5137 92.0199 45.792 92.0199H79.712C82.9904 92.0199 85.648 89.3247 85.648 85.9999C85.648 82.6751 82.9904 79.9799 79.712 79.9799H58.512C55.2337 79.9799 52.576 77.2847 52.576 73.9599C52.576 70.6351 55.2337 67.9399 58.512 67.9399H92.432C89.1537 67.9399 86.496 65.2447 86.496 61.9199C86.496 58.5951 89.1537 55.8999 92.432 55.8999H175.536ZM175.536 79.9799C178.814 79.9799 181.472 82.6751 181.472 85.9999C181.472 89.3247 178.814 92.0199 175.536 92.0199C172.258 92.0199 169.6 89.3247 169.6 85.9999C169.6 82.6751 172.258 79.9799 175.536 79.9799Z",
    fill: "#DFE5EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.105 105.546C118.524 105.546 131.834 92.2158 131.834 75.7728C131.834 59.3297 118.524 46 102.105 46C85.6858 46 72.3756 59.3297 72.3756 75.7728C72.3756 92.2158 85.6858 105.546 102.105 105.546Z",
    fill: "white",
    stroke: "#88C3E1",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.341 98.8746C98.9018 99.1631 100.49 99.313 102.105 99.3243C115.093 99.3243 125.622 88.7799 125.622 75.7728C125.622 62.7656 115.093 52.2212 102.105 52.2212C98.7682 52.2212 95.5941 52.917 92.719 54.1717C87.7228 56.3519 83.6297 60.2198 81.1576 65.0563C79.5146 68.2709 78.5876 71.9134 78.5876 75.7728C78.5876 79.2744 79.3507 82.5976 80.7194 85.5845C81.6965 87.717 82.9824 89.6782 84.5196 91.4107",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.341 98.8746C98.9018 99.1631 100.49 99.313 102.105 99.3243C115.093 99.3243 125.622 88.7799 125.622 75.7728C125.622 62.7656 115.093 52.2212 102.105 52.2212C98.7682 52.2212 95.5941 52.917 92.719 54.1717C87.7228 56.3519 83.6297 60.2198 81.1576 65.0563C79.5146 68.2709 78.5876 71.9134 78.5876 75.7728C78.5876 79.2744 79.3507 82.5976 80.7194 85.5845C81.6965 87.717 82.9824 89.6782 84.5196 91.4107",
    stroke: "#88C3E1",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2822 94.0581C89.1885 95.6098 91.3422 96.8686 93.6748 97.7658",
    stroke: "#88C3E1",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.509 99.3242L131.834 104.657",
    stroke: "#88C3E1",
    strokeWidth: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.973 103.795C129.294 105.477 129.294 108.204 130.973 109.886L140.811 119.738C142.49 121.42 145.214 121.42 146.893 119.738C148.573 118.056 148.573 115.329 146.893 113.647L137.056 103.795C135.376 102.113 132.653 102.113 130.973 103.795Z",
    fill: "#FFF7DE",
    stroke: "#88C3E1",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.383 105.545L145.145 115.322",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3364 65.5521C96.3364 75.8596 104.68 84.2156 114.972 84.2156C116.994 84.2156 118.941 83.8931 120.764 83.2967C117.788 90.6919 110.555 95.912 102.105 95.912C90.9983 95.912 81.9948 86.8952 81.9948 75.7725C81.9948 65.6938 89.3875 57.3443 99.0386 55.8657C97.324 58.6903 96.3364 62.0057 96.3364 65.5521Z",
    fill: "#FFF7DE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M102.549 59.3311C101.419 59.3311 100.315 59.4424 99.2475 59.6547M96.0221 60.6429C89.9512 63.1978 85.6881 69.2089 85.6881 76.2171",
    stroke: "#FFC107",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M154.176 86.684H146.92M159.788 79.772H144.546H159.788ZM166 79.772H164.029H166Z",
    stroke: "#F9FAFB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3065 106.236H67.051M70.157 98.4355H54.9146H70.157ZM49.746 98.4355H46H49.746Z",
    stroke: "#F9FAFB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyVehicle);
export default __webpack_public_path__ + "static/media/EmptyVehicle.624f72fe05d0d34000c294202b0e5d3a.svg";
export { ForwardRef as ReactComponent };